import { createContext, useState, useEffect, useContext } from "react";
import { AuthContext } from "./auth";

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
    const [en_web, setWebEn] = useState(JSON.parse(localStorage.getItem('language'))?.language_web_en)
    const [am_web, setWebAm] = useState(JSON.parse(localStorage.getItem('language'))?.language_web_am)
    const [ao_web, setWebOr] = useState(JSON.parse(localStorage.getItem('language'))?.language_web_ao)
    const [en_app, setAppEn] = useState(JSON.parse(localStorage.getItem('language'))?.language_app_en)
    const [am_app, setAppAm] = useState(JSON.parse(localStorage.getItem('language'))?.language_app_am)
    const [ao_app, setAppOr] = useState(JSON.parse(localStorage.getItem('language'))?.language_app_ao)

    useEffect(() => {
        const fetchData = async () => {
            try {

                const exists = localStorage.getItem('language')

                // if (exists === null || exists === undefined || exists === '') {
                const urls = 'https://metro.cheche.et/public/app/languages.json';

                const requests = await fetch(urls)

                const data = await requests.json();

                setWebOr(data.ao.translation)
                setWebEn(data.en.translation)
                setWebAm(data.am.translation)
                setAppEn({})
                setAppOr({})
                setAppAm({})



                const language = {
                    language_web_en: data.en.translation,
                    language_web_am: data.am.translation,
                    language_web_ao: data.ao.translation,
                    language_app_en: en_app,
                    language_app_am: am_app,
                    language_app_or: ao_app,
                };

                localStorage.setItem('language', JSON.stringify(language));
                // }

            } catch (error) {
                // Handle any errors that occur during the requests
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [en_web?.length, am_web?.length, ao_web?.length]);

    if (en_app && am_app && ao_app && en_web && am_web && ao_web) {
        const language = {
            language_web_en: en_web,
            language_web_am: am_web,
            language_web_ao: ao_web,
            language_app_en: en_app,
            language_app_am: am_app,
            language_app_ao: ao_app,
        };
        localStorage.setItem('language', JSON.stringify(language));
    }

    return (
        <LanguageContext.Provider
            value={{
                en_web, setWebEn,
                am_web, setWebAm,
                ao_web, setWebOr,
                en_app, setAppEn,
                am_app, setAppAm,
                ao_app, setAppOr
            }}
        >
            {children}
        </LanguageContext.Provider>
    )
};

export { LanguageProvider }